import React from 'react'

const TimerIcon = (props) => (

    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
        <path
            d="M50 54h-5v-6c0-7.591-4.147-14.44-10.714-18A20.428 20.428 0 0 0 45 12V6h5c1.654 0 3-1.346 3-3s-1.346-3-3-3H10C8.346 0 7 1.346 7 3s1.346 3 3 3h5v6c0 7.591 4.147 14.44 10.714 18A20.428 20.428 0 0 0 15 48v6h-5c-1.654 0-3 1.346-3 3s1.346 3 3 3h40c1.654 0 3-1.346 3-3s-1.346-3-3-3zM10 4a1.001 1.001 0 0 1 0-2h40a1.001 1.001 0 0 1 0 2H10zm7 8V6h26v6a18.45 18.45 0 0 1-11.203 17h-3.595A18.45 18.45 0 0 1 17 12zm0 36a18.45 18.45 0 0 1 11.203-17h3.595A18.45 18.45 0 0 1 43 48v6a1 1 0 0 0-2 0h-2a1 1 0 0 0-2 0h-2a1 1 0 0 0-2 0h-2a1 1 0 0 0-2 0h-2a1 1 0 0 0-2 0h-2a1 1 0 0 0-2 0h-2a1 1 0 0 0-2 0v-6zm33 10H10a1.001 1.001 0 0 1 0-2h40a1.001 1.001 0 0 1 0 2z"
            data-original="#000000" className="active-path" data-old_color="#8595a7" fill="#8595a7"/>
        <circle cx="20" cy="52" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="24" cy="52" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="28" cy="52" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="32" cy="52" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="36" cy="52" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="40" cy="52" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="22" cy="50" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="26" cy="50" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="33" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="24" cy="22" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="28" cy="22" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="32" cy="22" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="36" cy="22" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="34" cy="20" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="36" cy="18" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="26" cy="20" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="20" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="24" cy="18" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="26" cy="24" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="28" cy="26" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="32" cy="26" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="24" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="34" cy="24" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="36" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="39" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="42" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="45" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="30" cy="48" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="34" cy="50" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
        <circle cx="38" cy="50" r="1" data-original="#000000" className="active-path" data-old_color="#8595a7"
                fill="#8595a7"/>
    </svg>

)

export default TimerIcon



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Icons/TimerIcon.js